import React from 'react'
import WebinarForm from './../components/WebinarForm';
import WebinarBanner from '../components/Register-webinar-banner'

const Webinar = () => {
  return (
    <div>
        <WebinarBanner/>
        <WebinarForm/>
    </div>
  )
}

export default Webinar